
import { SyncOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import React, {
  useEffect, useMemo, useRef,
} from 'react';
import { useDispatch } from 'react-redux';
import displayLoading from '../../../redux/actions/loading';
import auth from '../../../utils/auth';
import { useIntersectionObserver, useMergeState } from '../../../utils/hooks';
import ReassignEIDModal from '../../components/modals/reassigneID';
import NormalTable from '../../components/tables/normalTable';
import {
  getReassignEIDSearchBy, getReassignEIDTableColumns, handleFetchReassignHistories,
} from './helper';
import './style.scss';


const ReassignEID = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useMergeState({
    isLoadingMore: false,
    visible: false,
    eSimHistories: [],
    cursor: undefined,
    lastElement: undefined,
  });
  const searchKey = useRef();
  const columns = useMemo(() => getReassignEIDTableColumns());
  const searchBy = useMemo(() => getReassignEIDSearchBy());

  const fetchInitData = async () => {
    dispatch(displayLoading(true));
    const reassignHistories = await handleFetchReassignHistories({}, 20);
    setState({
      eSimHistories: reassignHistories || [],
      cursor: reassignHistories.length < 20 ? undefined : reassignHistories[reassignHistories.length - 1]?.id || undefined,
    });
    dispatch(displayLoading(false));
  };

  const onSearchOrFilter = async (keySearch, filter) => {
    dispatch(displayLoading(true));
    searchKey.current = keySearch;
    const reassignEsimHistoriesFilterInput = { [searchKey.current.key]: searchKey.current.value };
    const reassignHistories = await handleFetchReassignHistories(reassignEsimHistoriesFilterInput, 20);
    setState({
      eSimHistories: reassignHistories || [],
      cursor: reassignHistories.length < 20 ? undefined : reassignHistories[reassignHistories.length - 1]?.id || undefined,
    });
    dispatch(displayLoading(false));
  };

  const handleLoadMore = async () => {
    if (state.isLoadingMore || !state.cursor) {
      return;
    }
    const reassignEsimHistoriesFilterInput = { cursor: state.cursor };
    if (searchKey.current) {
      Object.assign(reassignEsimHistoriesFilterInput, { [searchKey.current.key]: searchKey.current.value });
    }
    setState({ isLoadingMore: true });
    const reassignHistories = await handleFetchReassignHistories(reassignEsimHistoriesFilterInput, 20);
    if (!_.isEmpty(reassignHistories)) {
      setState({
        eSimHistories: [...state.eSimHistories, ...reassignHistories],
        cursor: reassignHistories.length < 20 ? undefined : reassignHistories[reassignHistories.length - 1]?.id || undefined,
      });
    }
    setState({ isLoadingMore: false });
  };
  const reassignEID = (data) => {
    const newestId = `${state.eSimHistories.length}`;
    const newHistory = {
      key: newestId,
      id: newestId,
      eID: data.eID,
      preAssignedAccount: data.currentAccount,
      newAccount: data.newAccount,
      dateTime: moment().format('DD/MM/YYYY - HH:mm:ss'),
      reassignedBy: `${auth.getLoginData().firstName} ${auth.getLoginData().lastName}`,
    };
    setState({
      eSimHistories: [newHistory, ...state.eSimHistories],
    });
  };

  const toggleModal = () => {
    setState({ visible: !state.visible });
  };

  useEffect(() => {
    fetchInitData();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(state.eSimHistories)) {
      const rowElements = document.querySelectorAll('.ant-table-row-level-0');
      setState({ lastElement: rowElements[rowElements.length - 1] });
    }
  }, [state.eSimHistories, state.isLoadingMore]);

  useIntersectionObserver(state.lastElement, handleLoadMore, () => {}, [state.eSimHistories, state.cursor]);
  return (
    <div className="reassign-eid">
      <NormalTable
        className="reassign-eid-table"
        columns={columns}
        dataSource={state.eSimHistories}
        isCreate
        isSearch
        searchBy={searchBy}
        createType="Reassign eID"
        icon={<SyncOutlined />}
        fetchData={onSearchOrFilter}
        onCreate={toggleModal}
      />
      <div className="loadmore">
        {state.isLoadingMore && <Spin />}
      </div>
      <ReassignEIDModal
        visible={state.visible}
        onCancel={toggleModal}
        onReassign={reassignEID}
      />
    </div>
  );
};

export default ReassignEID;
